import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { QuestionUploadPage } from '@/features/question/pages/QuestionUploadPage';
import { uploadSearchSchema } from '@/features/question/types/question.types';

export const Route = createFileRoute('/_auth/question/upload')({
  validateSearch: uploadSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Question Upload">
      <Suspense fallback={<PageLoader />}>
        <QuestionUploadPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
